import { render, staticRenderFns } from "./cirokaranalizi.vue?vue&type=template&id=dd842984&scoped=true"
import script from "./cirokaranalizi.vue?vue&type=script&lang=js"
export * from "./cirokaranalizi.vue?vue&type=script&lang=js"
import style0 from "./cirokaranalizi.vue?vue&type=style&index=0&id=dd842984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd842984",
  null
  
)

export default component.exports